import { useMemo } from 'react';
import tagIds from '~/constants/common/tagIds';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import useCanShowDeliveryAndPickupInfo from '~/hooks/vdp/selectors/useCanShowDeliveryAndPickupInfo';

export default function useShouldFetchBulkAndShipping() {
  const shouldFetchDeliveryAndPickup = useCanShowDeliveryAndPickupInfo();
  const { highlights } = useGetVehicleDetails();

  const hasEvTag = useMemo(
    () =>
      highlights?.some(
        highlight => highlight.tagId === tagIds.EvTaxCreditMayBeEligible
      ) ?? false,
    [highlights]
  );

  return hasEvTag || shouldFetchDeliveryAndPickup;
}
